import Loader from "../../components/Loader";
import {useQuery} from "@tanstack/react-query";
import {useContext, useEffect, useState} from "react";
import Paginator from "../../components/Paginator";
import {
    Col,
    Form,
    FormFeedback,
    Row,
    Input,
    Label,
    Button,
    UncontrolledAccordion,
    AccordionItem,
    AccordionHeader, AccordionBody, Accordion
} from "reactstrap";
import AuthContext from "../../context/AuthContext";
import handleUnauthorized401QueryError from "../../utils/handleUnauthorized401QueryError";
import {toast} from "react-toastify";
import RecordsNotFound from "../../components/RecordsNotFound";
import {getRefunds} from "../../api/api";
import Refund from "./Refund";
import {useLocation} from "react-router-dom";



function RefundPage() {
    const {refreshToken, user } = useContext(AuthContext)
    const location = useLocation();
    const refundOrderFromState = location.state?.refundOrder || "";
    const [page, setPage] = useState(1);
    const [refundId, setRefundId] = useState("");
    const [referenceRefundId, setReferenceRefundId] = useState("");
    const [referencePaymentId, setReferencePaymentId] = useState("");
    const [refundOrder, setRefundOrder] = useState(refundOrderFromState);
    const [refundType, setRefundType] = useState("");
    const [refundAmount, setRefundAmount] = useState("");
    const [currency, setCurrency] = useState("");
    const [instantRefund, setInstantRefund] = useState("");
    const [refundStatus, setRefundStatus] = useState("");
    const [refundReason, setRefundReason] = useState("");
    const [refundCreatedDate, setRefundCreatedDate] = useState("");
    const [refundUpdatedDate, setRefundUpdatedDate] = useState("");


    const [queryKey, setQueryKey] = useState(['refunds', page])
    const [openAdvancedSearch, setOpenAdvancedSearch] = useState(false);

    const [isAdvancedSearchDisabled, setIsAdvancedSearchDisabled] = useState(false);
    const [isRefundURLDisabled, setIsRefundURLDisabled] = useState(false);

    const toggleAdvancedSearch = () => setOpenAdvancedSearch((prevState) => !prevState);

    useEffect(() => {
        setQueryKey(['refunds', page]);
    }, [page]);

    useEffect(() => {
        if (!refundOrderFromState) return;
        setPage(1);
        setRefundId('');
        setReferenceRefundId('');
        setReferencePaymentId('');
        setRefundOrder(refundOrderFromState);
        setRefundType('');
        setRefundAmount('');
        setCurrency('');
        setInstantRefund('');
        setRefundStatus('');
        setRefundReason('');
        setRefundCreatedDate('');
        setRefundUpdatedDate('');
        setQueryKey(['refunds', 1, '', refundOrderFromState, '', '', '', '', '', '', '', '', '', '']);
    }, [refundOrderFromState]);

    useEffect(() => {
        if (
            refundId === '' && refundOrder === '' && referenceRefundId === '' && referencePaymentId === ''
            && refundType === '' && refundAmount === ''  && currency === '' && instantRefund === '' &&
            refundStatus  === '' && refundReason === ''  && refundCreatedDate === '' && refundUpdatedDate === ''
        ) {
            clearSearchRefund();
        }
    }, [
        refundId, referenceRefundId, referencePaymentId, refundOrder, refundType, refundAmount, currency, instantRefund, refundStatus, refundReason,  refundCreatedDate, refundUpdatedDate
    ]);

    const { status, data, error, isFetching, refetch } = useQuery({
        queryKey: queryKey,
        queryFn: () => getRefunds(
            page,  refundId, refundOrder, referenceRefundId, referencePaymentId, refundType, refundAmount, currency, instantRefund, refundStatus, refundReason,  refundCreatedDate, refundUpdatedDate
        ),
        keepPreviousData: true,
        retry: false,
        onError: (err) => {
            handleUnauthorized401QueryError(err, refreshToken, refetch);
            if (err.response.status !== 401) {
                toast.error(`An error occurred! ${err?.response?.data?.detail}`);
            }
        }
    });

    const searchRefund = (e) => {
        e?.preventDefault();
        setPage(1);
        setQueryKey([
            'refunds', page,  refundId,  refundOrder, referenceRefundId, referencePaymentId, refundType, refundAmount,
            currency, instantRefund, refundStatus, refundReason,  refundCreatedDate, refundUpdatedDate
        ]);
    };

    const clearSearchRefund = (e) => {
        e?.preventDefault()
        setRefundId('')
        setRefundOrder('')
        setReferenceRefundId('')
        setReferencePaymentId('')
        setRefundType('')
        setRefundAmount('')
        setCurrency('')
        setInstantRefund('')
        setRefundStatus('')
        setRefundReason('')
        setRefundCreatedDate('')
        setRefundUpdatedDate('')
        setQueryKey( ['refunds', 1])
        // setPage(1)
    };

    return (
        <>
            <UncontrolledAccordion defaultOpen="" flush={true}>
                <AccordionItem>
                    <AccordionHeader targetId="1">
                        <span><i className="mdi mdi-filter"/></span>
                    </AccordionHeader>
                    <AccordionBody accordionId="1">
                        <div className="card-box">
                            <div className="row">
                                <div className="col-sm-12">
                                    <Form onSubmit={searchRefund}>
                                        <Row className="form-row align-items-center">
                                            <Col>
                                                <Label className="visually-hidden" for="reference-refund-id">Refund ID</Label>
                                                <Input
                                                    id="reference-refund-id"
                                                    name="reference-refund-id"
                                                    type="text"
                                                    className="form-control mb-2"
                                                    onChange={(e) => setReferenceRefundId(e.target.value)}
                                                    value={referenceRefundId}
                                                    invalid={error && error.response.data.reference_refund_id}
                                                />
                                                <FormFeedback invalid>{error && error.response.data.reference_refund_id}</FormFeedback>
                                            </Col>
                                            <Col>
                                                <Label className="visually-hidden" for="reference-payment-id">Payment ID</Label>
                                                <Input
                                                    id="reference-payment-id"
                                                    name="reference-payment-id"
                                                    type="text"
                                                    className="form-control mb-2"
                                                    onChange={(e) => setReferencePaymentId(e.target.value)}
                                                    value={referencePaymentId}
                                                    invalid={error && error.response.data.reference_payment_id}
                                                />
                                                <FormFeedback invalid>{error && error.response.data.reference_payment_id}</FormFeedback>
                                            </Col>
                                            <Col>
                                                <Label className="visually-hidden" for="amount">Amount</Label>
                                                <Input
                                                    id="amount"
                                                    name="amount"
                                                    type="text"
                                                    className="form-control mb-2"
                                                    onChange={(e) => setRefundAmount(e.target.value)}
                                                    value={refundAmount}
                                                    invalid={error && error.response.data.amount}
                                                />
                                                <FormFeedback invalid>{error && error.response.data.amount}</FormFeedback>
                                            </Col>
                                            <Col>
                                                <Label className="visually-hidden" for="refund-status">Status</Label>
                                                <Input
                                                    type="select"
                                                    id="refund-status"
                                                    className="form-control mb-2"
                                                    value={refundStatus}
                                                    onChange={(e) => setRefundStatus(e.target.value)}
                                                >
                                                    <option value="">--</option>
                                                    <option value={"PENDING"}>Pending</option>
                                                    <option value={"FAILED"}>Failed</option>
                                                    <option value={"CREATED"}>Created</option>
                                                    <option value={"PROCESSED"}>Processed</option>

                                                </Input>
                                            </Col>
                                            <Col>
                                                <Label className="visually-hidden" for="date-created">Date Created</Label>
                                                <Input
                                                    id="date-created"
                                                    name="date-created"
                                                    type="date"
                                                    className="form-control mb-2"
                                                    onChange={(e) => setRefundCreatedDate(e.target.value)}
                                                    value={refundCreatedDate}
                                                    invalid={error && error.response.data.created}
                                                />
                                                <FormFeedback invalid>{error && error.response.data.created}</FormFeedback>
                                            </Col>
                                        </Row>
                                        {!isAdvancedSearchDisabled && (
                                            <>
                                                <Row className="form-row align-items-center">
                                                    <Col>
                                                        <div className="form-check">
                                                            <Input
                                                                type="checkbox"
                                                                className="form-check-input"
                                                                id="advanced-search"
                                                                defaultChecked={openAdvancedSearch}
                                                                disabled={isAdvancedSearchDisabled}
                                                                onChange={() => toggleAdvancedSearch()}
                                                            />
                                                            <Label check className="form-check-label mb-2" for="advanced-search">
                                                                Advanced Search
                                                            </Label>
                                                        </div>
                                                    </Col>
                                                </Row>
                                                <Accordion open={openAdvancedSearch}>
                                                    <AccordionItem>
                                                        <AccordionBody accordionId={true}>
                                                            <Row className="form-row align-items-center">
                                                                <Col>
                                                                    <Label className="visually-hidden" for="refund-type">Refund Type</Label>
                                                                    <Input
                                                                        type="select"
                                                                        id="inputState"
                                                                        className="form-control mb-2"
                                                                        value={refundType}
                                                                        onChange={(e) => setRefundType(e.target.value)}
                                                                    >
                                                                        <option value="">--</option>
                                                                        <option value={"PARTIAL"}>Partial</option>
                                                                        <option value={"FULL"}>Full</option>
                                                                    </Input>
                                                                </Col>
                                                                <Col>
                                                                    <Label
                                                                        className="visually-hidden"
                                                                        for="order-id"
                                                                    >
                                                                        Order ID
                                                                    </Label>
                                                                    <Input
                                                                        id="order-id"
                                                                        name="order-id"
                                                                        type="text"
                                                                        className="form-control mb-2"
                                                                        onChange={(e) =>
                                                                            setRefundOrder(
                                                                                e.target.value
                                                                            )
                                                                        }
                                                                        value={refundOrder}
                                                                        invalid={
                                                                            error && error.response.data.order
                                                                        }
                                                                    />
                                                                    <FormFeedback invalid>
                                                                        {error && error.response.data.order}
                                                                    </FormFeedback>
                                                                </Col>
                                                                <Col>
                                                                    <Label className="visually-hidden" for="refund-reason">Refund Reason</Label>
                                                                    <Input
                                                                        id="refund-reason"
                                                                        name="refund-reason"
                                                                        type="text"
                                                                        className="form-control mb-2"
                                                                        onChange={(e) => setRefundReason(e.target.value)}
                                                                        value={refundReason}
                                                                        invalid={error && error.response.data.refund_reason}
                                                                    />
                                                                    <FormFeedback invalid>{error && error.response.data.refund_reason}</FormFeedback>
                                                                </Col>

                                                                <Col>
                                                                    <Label className="visually-hidden" for="instant-refund">Instant Refund</Label>
                                                                    <Input
                                                                        type="select"
                                                                        id="inputState"
                                                                        className="form-control mb-2"
                                                                        value={instantRefund}
                                                                        onChange={(e) => setInstantRefund(e.target.value)}
                                                                    >
                                                                        <option value="">--</option>
                                                                        <option value={true}>True</option>
                                                                        <option value={false}>false</option>
                                                                    </Input>
                                                                </Col>
                                                                <Col>
                                                                    <Label className="visually-hidden" for="date-updated">Date Updated</Label>
                                                                    <Input
                                                                        id="date-updated"
                                                                        name="date-updated"
                                                                        type="date"
                                                                        className="form-control mb-2"
                                                                        onChange={(e) => setRefundUpdatedDate(e.target.value)}
                                                                        value={refundUpdatedDate}
                                                                        invalid={error && error.response.data.updated}
                                                                    />
                                                                    <FormFeedback invalid>{error && error.response.data.updated}</FormFeedback>
                                                                </Col>
                                                            </Row>
                                                        </AccordionBody>
                                                    </AccordionItem>
                                                </Accordion>
                                            </>
                                        )}
                                        <Row className="form-row align-items-center">
                                            {isAdvancedSearchDisabled && (
                                                <Col>
                                                    <Button
                                                        type="submit"
                                                        className="btn bx-btn-primary waves-effect waves-light mr-2"
                                                        disabled={!referenceRefundId && !referencePaymentId
                                                            && !refundAmount && !refundStatus && !refundCreatedDate}
                                                    >
                                                        Search
                                                    </Button>
                                                    <Button
                                                        type="button"
                                                        onClick={clearSearchRefund}
                                                        className="btn bx-btn-primary waves-effect waves-light"
                                                        disabled={!referenceRefundId && !referencePaymentId
                                                            && !refundAmount && !refundStatus && !refundCreatedDate}
                                                    >
                                                        Clear
                                                    </Button>
                                                </Col>
                                            )}
                                            {!isAdvancedSearchDisabled && (
                                                <Col>
                                                    <Button
                                                        type="submit"
                                                        className="btn bx-btn-primary waves-effect waves-light mr-2"
                                                        disabled={!refundId && !referenceRefundId && !referencePaymentId
                                                            && !refundStatus && !refundCreatedDate && !refundOrder
                                                            && !refundType && !refundAmount  && !instantRefund
                                                            && !refundReason && !refundUpdatedDate}
                                                    >
                                                        Search
                                                    </Button>
                                                    <Button
                                                        type="button"
                                                        onClick={clearSearchRefund}
                                                        className="btn bx-btn-primary waves-effect waves-light"
                                                        disabled={!referenceRefundId && !referencePaymentId &&
                                                            !refundStatus && !refundCreatedDate && !refundOrder
                                                            && !refundType && !refundAmount && !instantRefund
                                                            && !refundReason && !refundUpdatedDate}
                                                    >
                                                        Clear
                                                    </Button>
                                                </Col>
                                            )}
                                        </Row>
                                    </Form>
                                </div>
                            </div>
                        </div>
                    </AccordionBody>
                </AccordionItem>
            </UncontrolledAccordion>
            {status === 'loading' && (
                <Loader size={'default'} />
            )}
            {status === 'success' | error?.response?.status === 401 && (
                <div className="row">
                    <div className="col-12">
                        <div className="card-box">
                            {/*<AddProductButton />*/}
                            <div className="table-responsive">
                                <table className="table table-centered mb-0">
                                    <thead className="font-13 bg-light text-muted">
                                    <tr>
                                        <th className="font-weight-medium">Refund ID</th>
                                        <th className="font-weight-medium">Order Number</th>
                                        <th className="font-weight-medium">Type</th>
                                        <th className="font-weight-medium">Status</th>
                                        <th className="font-weight-medium">Amount</th>
                                        <th className="font-weight-medium">Created</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {data?.count > 0 ? data?.results?.map(refund => (
                                        <Refund key={refund.id} refund={refund} isRefundURLDisabled={isRefundURLDisabled} />
                                    )) : <RecordsNotFound />}
                                    </tbody>
                                </table>
                            </div>
                            {status === 'success' && (
                                <Paginator data={data} page={page} setPage={setPage} last={data?.last_page} loading={isFetching}/>
                            )}
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

export default RefundPage;
